module.exports = __webpack_public_path__ + "static/img/son2_active.f8358038.jpg";